import { render, staticRenderFns } from "./TabParcel.vue?vue&type=template&id=0c7a8485&"
import script from "./TabParcel.vue?vue&type=script&lang=js&"
export * from "./TabParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports